import { EuiButtonIcon, EuiHealth } from "@elastic/eui";
import {
  ActionIcon,
  Button,
  Flex,
  Grid,
  Group,
  Select,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import { modals } from "@mantine/modals";
import React, { useEffect, useState } from "react";

import DeleteView from "./DeleteView";

import { DatePickerInput } from "@mantine/dates";
import { useForm } from "@mantine/form";
import { IconSearch, IconTimeDuration15 } from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_PaginationState,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import { useLocation, useNavigate } from "react-router-dom";
import { styleTableMantine } from "../../_base/_const/_constVar";
import BreadCrumb from "../../_base/component/_layout/_breadcrumb";
import { NotificationExtension } from "../../_base/extension/NotificationExtension";
import Repository from "../../_base/helper/HttpHelper";
import AppAction from "../../common/AppAction";
import { formatDateNotTimeZone } from "../../common/FormatDate/FormatDate";
import { _localization } from "../../config/location";
import { API_ROUTE } from "../../const/apiRoute";
import { TblComboSet } from "../../model/Comboset";
import { MessageResponse } from "../../model/MessageResponse";

type SearchCriteria = {
  keySearch?: string;
  Status: string;
  FormDate: string;
  ToDate: string;
};
const ComboSet = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [datas, setDatas] = useState<TblComboSet[]>([]);
  const [deleteViewStatus, setDeleteViewStatus] = useState(false);
  const [height, setHeight] = useState(0);
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [isError, setIsError] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [pagination, setPagination] = useState<MRT_PaginationState>({
    pageIndex: 0,
    pageSize: 20,
  });
  const [selectIds, setSelectIds] = useState<any[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [total, setTotal] = useState(0);
  const [rowCount, setRowCount] = useState(0);
  const sizeGrid = { base: 6, sm: 3, md: 3, lg: 3, xl: 1.7 };
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";

  const form = useForm<SearchCriteria>({
    mode: "uncontrolled",
    initialValues: {
      keySearch: _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
      Status: _searchJson && checkedPinSearch ? _searchJson?.Status : "",
      FormDate: _searchJson && checkedPinSearch ? _searchJson?.FormDate : "",
      ToDate: _searchJson && checkedPinSearch ? _searchJson?.ToDate : "",
    },
  });

  const getStatusColor = (status: any) => {
    switch (status) {
      case "I":
        return "red";
      case "A":
        return "green";
      default:
        return "subdued";
    }
  };

  const getTypeArticle = (type: any) => {
    switch (type) {
      case 1:
        return "Chỉ hiển thị danh mục con";
      case 2:
        return "Chỉ hiển thị bài";
      case 3:
        return "Hiển thị bài + Danh mục con";
      default:
        return "Chỉ hiển thị danh mục con";
    }
  };

  // mở modal xóa
  const deleteItem = (idItem: (number | string)[]) => {
    modals.openConfirmModal({
      title: (
        <>
          <Title order={5}>Xóa ComboSet</Title>
        </>
      ),
      children: <DeleteView idItem={idItem} onClose={setDeleteViewStatus} />,
      confirmProps: { display: "none" },
      cancelProps: { display: "none" },
    });
  };
  const openModalDelete = () => {
    if (selectIds && selectIds.length < 1)
      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
    else {
      // const ids = selectIds.map((id) => Number(id));
      deleteItem(selectIds);
    }
  };

  const openModal = () => {
    navigate("/combo/combo-set-add");
  };

  // Hàm xử lý chỉnh sửa combo set
  const editComboSet = (
    id: number,
    type: string = "edit",
    setName: string = "",
    openInNewTab: boolean = false
  ) => {
    // Kiểm tra localStorage trước
    let tabParam = null;
    try {
      const storedData = localStorage.getItem("hacom_edit_comboset");
      if (storedData) {
        const comboSetData = JSON.parse(storedData);
        if (comboSetData.tab && comboSetData.id === id) {
          tabParam = comboSetData.tab;
        }
      }
    } catch (error) {
      console.error("Error reading tab from localStorage:", error);
    }

    // Nếu không có trong localStorage, thử lấy từ URL
    if (!tabParam) {
      const queryParams = new URLSearchParams(location.search);
      tabParam = queryParams.get("tab");
    }

    const comboSet = datas.find((item) => item.id === id);
    const comboSetName = comboSet ? comboSet.setName : setName;

    navigate(`/combo/combo-set-edit/${id}`, {
      state: {
        type: type,
        setName: comboSetName ? comboSetName : "",
        initialTab: tabParam ? tabParam : undefined,
      },
    });
  };

  const editItem = (id: number) => {
    // navigate("/combo/combo-set-edit", { state: { id: id } });
    if (id) {
      editComboSet(id, "edit", "", false);
    }
  };

  const fetchDataComboSet = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    const search = form.getValues();
    const repository = new Repository(process.env.REACT_APP_Demo_APP_API_URL);
    const queryParams = new URLSearchParams();
    try {
      queryParams.append(
        "Skip",
        String(pagination.pageIndex * pagination.pageSize)
      );
      queryParams.append("Take", String(pagination.pageSize));
      if (search.keySearch) {
        queryParams.append("KeySearch", search.keySearch.trim().toLowerCase());
      }
      if (search.Status) {
        queryParams.append("Status", search.Status);
      }
      if (search.FormDate) {
        queryParams.append("FormDate", search.FormDate);
      }
      if (search.ToDate) {
        queryParams.append("ToDate", search.ToDate);
      }
      const urlSearch = `${
        API_ROUTE.GET_LIST_COMBO_SET
      }?${queryParams.toString()}`;

      let callapi = await repository.get<MessageResponse<any[]>>(urlSearch);
      if (callapi && callapi.success) {
        setDatas(callapi?.data ?? []);
        setRowCount(callapi?.totalCount ?? 0);
        setTotal(callapi?.totalCount ?? 0);
        setSelectIds([]);
        table.resetRowSelection();
      } else {
        setRowCount(0);
        setIsLoading(false);
      }
      return callapi?.data;
    } catch (error: any) {
      setDatas([]);
      setIsError(true);
      return null;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...form.getValues(),
          pageSize: pagination.pageSize,
          pageIndex: pagination.pageIndex,
        })
      );
    }
  };
  const columns = React.useMemo<MRT_ColumnDef<TblComboSet>[]>(
    () => [
      {
        accessorKey: "setName",
        header: "Tên Combo Set",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        size: 320,
      },
      {
        accessorKey: "description",
        header: "Mô tả Combo Set",
        Cell: ({ renderedCellValue }) => <>{renderedCellValue}</>,
        size: 410,
      },
      {
        accessorKey: "countProduct",
        header: "Số sản phẩm trong Combo Set",
        Cell: ({ renderedCellValue }) => (
          <>
            <Text c="red">{renderedCellValue}</Text>
          </>
        ),
        size: 410,
      },
      // {
      //   id: "comboSetCount",
      //   header: "Số sản phẩm trong Combo Set",
      //   accessorFn: (row) => row.tblComboSetGroupModels,
      //   Cell: ({ row }) => {
      //     const online = row.original;
      //     const count = Array.isArray(online?.tblComboSetGroupModels)
      //       ? online.tblComboSetGroupModels.reduce(
      //           (total: number, item: any) => {
      //             return total + (item?.tblComboSetProdModels?.length || 0);
      //           },
      //           0
      //         )
      //       : 0;

      //     return <Text c="red">{count}</Text>;
      //   },
      //   size: 200,
      // },
      {
        accessorKey: "status",
        header: "Trạng thái",
        Cell: ({ cell }) => {
          const status = cell.getValue<string>();
          return (
            <EuiHealth color={getStatusColor(status)}>
              {status === "A" ? "Hoạt động" : "Không hoạt động"}
            </EuiHealth>
          );
        },
        size: 120,
      },
      {
        id: "action",
        header: "Thao tác",
        Cell: ({ row }) => {
          const online = row.original;
          return (
            <Group justify="center" gap="xs">
              <Tooltip label="Chỉnh sửa">
                <ActionIcon
                  variant="subtle"
                  aria-label="Settings"
                  onClick={(e) => {
                    if (!online) {
                      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
                    } else {
                      if (typeof online.id === "number") {
                        // Kiểm tra nếu nhấn Ctrl+Click hoặc Middle Click để mở tab mới
                        if (e.ctrlKey || e.button === 1) {
                          // Lưu thông tin vào localStorage để tab mới có thể sử dụng
                          const comboSetData = {
                            id: online.id,
                            type: "edit",
                            setName: online.setName,
                            timestamp: new Date().getTime(),
                          };
                          localStorage.setItem(
                            "hacom_edit_comboset",
                            JSON.stringify(comboSetData)
                          );

                          // Mở tab mới
                          const baseUrl =
                            window.location.origin + window.location.pathname;
                          window.open(baseUrl, "_blank");
                        } else {
                          // Chỉnh sửa bình thường
                          editComboSet(
                            online.id,
                            "edit",
                            online.setName,
                            false
                          );
                        }
                      } else {
                        NotificationExtension.Warn("ID không hợp lệ!");
                      }
                    }
                  }}
                  onMouseDown={(e) => {
                    // Xử lý middle click
                    if (
                      e.button === 1 &&
                      online &&
                      typeof online.id === "number"
                    ) {
                      e.preventDefault();
                      const comboSetData = {
                        id: online.id,
                        type: "edit",
                        setName: online.setName,
                        timestamp: new Date().getTime(),
                      };
                      localStorage.setItem(
                        "hacom_edit_comboset",
                        JSON.stringify(comboSetData)
                      );
                      const baseUrl =
                        window.location.origin + window.location.pathname;
                      window.open(baseUrl, "_blank");
                    }
                  }}
                >
                  <EuiButtonIcon iconType="documentEdit" color="success" />
                </ActionIcon>
              </Tooltip>

              <Tooltip label="Xoá">
                <ActionIcon
                  variant="subtle"
                  aria-label="Settings"
                  onClick={() => {
                    if (!online) {
                      NotificationExtension.Warn("Xin vui lòng chọn dữ liệu !");
                    } else {
                      if (online.id !== undefined && online.id !== null) {
                        deleteItem([online.id]);
                      } else {
                        NotificationExtension.Warn("ID không hợp lệ!");
                      }
                    }
                  }}
                >
                  <EuiButtonIcon iconType="trash" color="danger" />
                </ActionIcon>
              </Tooltip>
            </Group>
          );
        },
        size: 80,
        enableColumnActions: false,
        enableSorting: false,
      },
    ],
    [datas, deleteViewStatus]
  );
  const table = useMantineReactTable({
    columns,
    data: datas,
    enableColumnResizing: true,
    rowCount,
    enableColumnFilters: true,
    enableSorting: true,
    enableColumnActions: true,
    enableTopToolbar: false,
    enablePagination: true,
    localization: _localization,
    state: {
      // columnFilters,
      // globalFilter,
      isLoading,
      pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading,
      rowSelection,
    },
    enableRowSelection: true,
    enableStickyFooter: true,
    manualFiltering: false,
    manualPagination: true,
    manualSorting: false,
    onPaginationChange: setPagination,
    positionToolbarAlertBanner: "bottom",
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        left: ["STT"],
        right: ["action"],
      },
      columnVisibility: { id: false },
      density: "xs",
    },
    mantineTopToolbarProps: {
      style: {
        display: "none",
      },
    },
    getRowId: (row) => String(row.id),
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    onRowSelectionChange: setRowSelection,
    mantineTableBodyCellProps: ({ row }) => ({
      style: styleTableMantine,
    }),
    mantineToolbarAlertBannerProps: false
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,

    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      radius: "xl",
      size: "lg",
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    mantineTableBodyRowProps: ({ row }) => ({
      onClick: row.getToggleSelectedHandler(),
      sx: { cursor: "pointer" },
    }),
  });

  useEffect(() => {
    const fetchData = async () => {
      await fetchDataComboSet();
    };
    fetchData();
  }, [pagination.pageIndex, pagination.pageSize, deleteViewStatus]);
  useEffect(() => {
    const valuesList = Object.keys(rowSelection);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelection);
      setSelectIds(valuesList);
    }
  }, [rowSelection]);
  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (250 + headerHeight));
    };

    handleResize();
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [height]);

  useEffect(() => {
    if (_searchJson) {
      setPagination({
        pageIndex: _searchJson.pageIndex,
        pageSize: _searchJson.pageSize,
      });
    }
  }, []);

  // useEffect để lắng nghe state từ navigation và reload data khi cần
  useEffect(() => {
    if (location.state?.shouldReload) {
      // Reload data khi có thông báo từ EditView
      setTimeout(() => {
        fetchDataComboSet();
      }, 100);
      // Clear state để tránh reload không cần thiết
      navigate(location.pathname, {
        replace: true,
        state: undefined,
      });
    }
  }, [location.state]);

  // Xử lý khi URL có tham số để mở modal editComboSet
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const openEdit = queryParams.get("openEdit");
    const idParam = queryParams.get("id");
    const tabParam = queryParams.get("tab");
    const setNameParam = queryParams.get("setName");
    const typeParam = queryParams.get("type") || "edit";

    if (openEdit === "true" && idParam) {
      // Mở modal chỉnh sửa combo set với tham số từ URL (fullScreen = true cho tab mới)
      editComboSet(parseInt(idParam), typeParam, setNameParam || "", true);

      // Clear URL params after handling, but add a small delay
      setTimeout(() => {
        navigate("/combo/combo-set", { replace: true });
      }, 500); // Give time for the modal to open
    }
  }, [location.search, navigate]);

  useEffect(() => {
    const directQueryParams = new URLSearchParams(window.location.search);
    const directOpenEdit = directQueryParams.get("openEdit");
    const directIdParam = directQueryParams.get("id");
    const directTabParam = directQueryParams.get("tab");
    const directSetNameParam = directQueryParams.get("setName");
    const directTypeParam = directQueryParams.get("type") || "edit";

    if (directOpenEdit === "true" && directIdParam) {
      setTimeout(() => {
        editComboSet(
          parseInt(directIdParam),
          directTypeParam,
          directSetNameParam || "",
          true // fullScreen = true cho direct URL access
        );

        // Clean URL but keep the page path
        if (window.history && window.history.replaceState) {
          const cleanUrl = window.location.pathname;
          window.history.replaceState({}, document.title, cleanUrl);
        }
      }, 300);
    }
  }, []); // Empty dependency array - runs only once on mount

  useEffect(() => {
    try {
      // Retrieve data from localStorage
      const storedData = localStorage.getItem("hacom_edit_comboset");
      if (storedData) {
        const comboSetData = JSON.parse(storedData);
        const currentTime = new Date().getTime();
        const dataTime = comboSetData.timestamp || 0;

        if (currentTime - dataTime < 300000) {
          if (comboSetData.id) {
            editComboSet(
              parseInt(comboSetData.id),
              comboSetData.type || "edit",
              comboSetData.setName || "",
              true // fullScreen = true cho localStorage (từ tab mới)
            );
            localStorage.removeItem("hacom_edit_comboset");
          }
        } else {
          localStorage.removeItem("hacom_edit_comboset");
        }
      }
    } catch (error) {
      console.error("Error processing localStorage data:", error);
      localStorage.removeItem("hacom_edit_comboset");
    }
  }, []);

  return (
    <>
      <Flex
        justify="space-between"
        align="center"
        style={{
          border: "1px solid #dee2e6",
          padding: "5px 10px",
        }}
      >
        <BreadCrumb />
        <AppAction
          openModal={openModal}
          openModalDelete={openModalDelete}
          // openModalEdit={openModalEdit}
        />
      </Flex>
      <Grid style={{ width: "100%" }} mb={10} mt={10}>
        <Grid.Col span={sizeGrid}>
          <TextInput
            placeholder="Nhập tìm kiếm"
            key={form.key("keySearch")}
            leftSection={<IconSearch size={20} color="#15aabf" />}
            onKeyDown={async (e) => {
              if (e.key === "Enter") {
                await fetchDataComboSet();
              }
            }}
            {...form.getInputProps("keySearch")}
          />
        </Grid.Col>

        <Grid.Col span={sizeGrid}>
          <DatePickerInput
            size="sm"
            placeholder="Chọn ngày bắt đầu"
            locale="vi"
            valueFormat="DD/MM/YYYY"
            leftSection={<IconTimeDuration15 color="#15aabf" />}
            value={
              form.getValues()?.FormDate &&
              form.getValues()?.FormDate?.length > 0
                ? new Date(form.getValues()?.FormDate)
                : null
            }
            onChange={(date) => {
              form.setValues((prev) => ({
                ...prev,
                FormDate: date ? formatDateNotTimeZone(date) : "",
              }));
            }}
            clearable
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <DatePickerInput
            style={{ border: "1px solidrgb(0, 0, 0)" }}
            size="sm"
            placeholder="Chọn ngày kết thúc"
            locale="vi"
            valueFormat="DD/MM/YYYY"
            leftSection={<IconTimeDuration15 size={20} color="#15aabf" />}
            value={
              form.getValues()?.ToDate && form.getValues()?.ToDate?.length > 0
                ? new Date(form.getValues()?.ToDate)
                : null
            }
            onChange={(date) => {
              form.setValues((prev) => ({
                ...prev,
                ToDate: date ? formatDateNotTimeZone(date) : "",
              }));
            }}
            clearable
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <Select
            placeholder="Trạng thái"
            size="sm"
            data={[
              { value: "A", label: "Hoạt động" },
              { value: "I", label: "Không hoạt động" },
            ]}
            {...form.getInputProps("Status")}
            clearable
          />
        </Grid.Col>
        <Grid.Col span={sizeGrid}>
          <Button
            color="blue"
            variant="outline"
            onClick={async () => {
              await fetchDataComboSet();
            }}
          >
            Tìm kiếm
          </Button>
        </Grid.Col>
      </Grid>

      <MantineReactTable table={table} />
    </>
  );
};

export default ComboSet;
